import axios from 'axios'

var instance = axios.create({
  timeout: 5000
})
// 配置请求头
instance.defaults.headers.get['Content-Type'] = 'application/json; charset=utf-8'

export function wechatShare ({
  title = '剧集上新由你决定',
  desc = '可获得剧集冠名以及限免权利',
  link = '',
  imgUrl = 'https://activity-1254361794.file.myqcloud.com/outsource/share.jpg'
}) {
  const shareUrl = encodeURIComponent(window.location.href)
  instance.get('https://activity.mddcloud.com.cn/api/jssdk?url=' + shareUrl)
    .then(function (res) {
      // console.log('share',res)
      if (res.data.code == 200) {
        var _data = res.data.data
        console.log('axios', _data)
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: _data.appId, // 必填，公众号的唯一标识
          timestamp: _data.timestamp, // 必填，生成签名的时间戳
          nonceStr: _data.noncestr, // 必填，生成签名的随机串
          signature: _data.signature, // 必填，签名，见附录1
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })

        wx.ready(() => {
          var commonShareData = {
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link,
            imgUrl: imgUrl,
            success: () => {
              // 用户确认分享后执行的回调函数
            },
            cancel: () => {
              // 用户取消分享后执行的回调函数
            }
          }
          wx.updateAppMessageShareData(commonShareData)
          wx.updateTimelineShareData(commonShareData)
        })

        wx.error(res => {
          // alert(JSON.stringify(res))
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
      }
    })
    .catch(function (error) {
      console.log(error)
    })
}
